import Scenario from '../api/Scenario';
import { cycle } from '../store/Cycle';
import BaseDashboardView from './BaseDashboardView';


class BaseScenarioDashboardView extends BaseDashboardView {
  static model = Scenario;

  getQueryParams() {
    return {
      ...cycle.params,
      ...super.getQueryParams(),
    };
  }
}


export default BaseScenarioDashboardView;
